$( document ).ready(function() {
  console.log( "ready!" );
  const currentUrl = location.href;
  const isDeUrl = currentUrl.includes('foracare.de/de')
  const lang = localStorage.getItem('wglang')
  const autoLang = localStorage.getItem('autolang')
  if (lang!== 'de' && autoLang === 'de') {
    localStorage.setItem('wglang', 'de')
    if (isDeUrl) {
      window.location.reload();
    } else {
      const newUrl = currentUrl.replace('foracare.de', 'foracare.de/de');
      window.location.href = newUrl;
    }
  } else if (isDeUrl) {
    if (lang === 'en') {
      const newUrl = currentUrl.replace('foracare.de/de', 'foracare.de');
      window.location.href = newUrl;
    }
  } else {
    if (lang === 'de') {
      const newUrl = currentUrl.replace('foracare.de', 'foracare.de/de');
      window.location.href = newUrl;
    }
  }
  // Removed unused block
  const freqList = document.getElementById('sn-product-widget')
  if (freqList) {
    freqList.innerHTML = ''
  }

  // Translate if German
  if (lang === 'de') {
    let isCheckCartBtn = false;
    const cartNode = document.getElementsByClassName('cart__items');
    let cartNum = '0';
    let isTransSub = false;

    setTimeout(doTranslateCart, 1000)

    function doTranslateCart() {
      let isTransSub = false;
      if (!isTransSub) {
        const sealDiv = document.querySelector('#seal-login-helper')
        if (sealDiv) {
          isTransSub = true;
          sealDiv.innerHTML = '<h5>Benötigen Sie Hilfe beim Abschließen des Abonnements?</h5><p><a class="link link--underline" href="/de/a/subscriptions/login">Klicken Sie hier</a></p>'
        }
      }
      if (cartNode.length > 0) {
        let currentCartNum = cartNode[0].getAttribute('data-count')
        if (currentCartNum != cartNum && currentCartNum > 0) {
          cartNum = currentCartNum
          // do check translate
          const textNodeList = document.querySelectorAll('.cart__items .cart__item--name>div')
          textNodeList.forEach((elem)=>{
            let newStr = elem.innerText
            newStr = newStr.replace('month Subscription for', 'monatiges Abonnement für')
            newStr = newStr.replace('monthly', 'Monat')
            elem.innerText = newStr;
          })
        }
      }
      
      if (!isCheckCartBtn) {
        const cartBtn = document.querySelector('#CartDrawer .cart__checkout')
        if (cartBtn) {
          if (cartBtn.innerText === 'One Meter Only. Check Cart') {
            cartBtn.innerText = 'Nur ein Meter. Überprüfen Sie den Warenkorb';
          }
          const observer = new MutationObserver(mutations => { 
            mutations.forEach(function (mutation) {
              if (mutation.type === 'attributes') {
                if (cartBtn.innerText === 'One Meter Only. Check Cart') {
                  cartBtn.innerText = 'Nur ein Meter. Überprüfen Sie den Warenkorb';
                } 
              }
            });
          });
          observer.observe(cartBtn, { attributes: true });
          isCheckCartBtn = true;

          const outer = document.querySelector('.cart__footer');
          if (outer) {
            outer.addEventListener('click', function (e) {
              setTimeout(()=>{
                const bodyText = document.querySelector('.orichiWrapperPop .orichiPopupBody .orichi-limit-alert');
                if (bodyText) {
                  bodyText.innerText = 'Sie können pro Abonnement nur ein (1) FORA 6 DUO erwerben. Bitte überprüfen Sie Ihren Warenkorb und versuchen Sie es erneut.';
                }
              }, 0)
            }, true);
          }
        }
      }
      setTimeout(doTranslateCart, 1000)
    }
  }  

  document.getElementById('weglot-language-en').addEventListener('click', function(){
    if (lang === 'en') {
      return
    } else {
      localStorage.setItem('autolang', 'en')
      setTimeout(()=>{
        window.location.reload();
      }, 0)
    }
  })
  document.getElementById('weglot-language-de').addEventListener('click', function(){
    if (lang === 'de') {
      return
    } else {
      localStorage.setItem('autolang', 'de')
      setTimeout(()=>{
        window.location.reload();
      }, 0)
    }
  })
});